const apiURL = process.env.REACT_APP_API_URL;
const loginURL = process.env.REACT_APP_LOGIN_URL;

async function client(endpoint, { method, data, dataType, token, headers: customHeaders, ...customConfig } = {}) {

  const baseUrl = endpoint === 'users/login' || endpoint ===  'users/verify-reset-password' || endpoint === 'users/reset-password' ? loginURL : apiURL;
  // localstorage.getItem('access-token', token);
  const accessToken = token || localStorage.getItem('access-token');
  const config = {
    method: method,
    body: dataType ? data : data ? JSON.stringify(data) : undefined,
    headers: {
      // Later on we will add Bearer before token
      // Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
      Authorization: accessToken ? `Bearer ${JSON.parse(accessToken)}` : undefined,
      'accept-language': 'en',
      'Content-Type': data ? 'application/json' : undefined,
      ...customHeaders,
    },
    ...customConfig,
  };

  // In case of file upload, we let browser handle content-type
  if (dataType === 'formData') delete config.headers['Content-Type'];

  // return window.fetch(`${apiURL}/${endpoint}`, config).then(async response => {
    return window.fetch(`${baseUrl}/${endpoint}`, config).then(async response => {
    if (response.status === 401) {
      if (window.__dev__) console.log('Error 401 ', response);
      // window.location.assign(window.location);
      return Promise.reject({ message: 'Please re-authenticate.' });
    }
    const data = await response.json();
    console.log(' data is ', data);
    if (response.ok) {
      return data;
    } else {
      return Promise.reject(data);
    }
  });
}

export { client };
